/**
 * Component: Discount tracker
 *
 * @namespace discountTracker
 */

/**
 * DOM selectors
 */
const discountSelectors = {
  container: '[js-discount-tracker="container"]',
  prevButton: '[js-discount-tracker="prev"]',
  nextButton: '[js-discount-tracker="next"]',
  slide: '[js-discount-tracker="slide"]'
};

document.addEventListener('DOMContentLoaded', () => {
  /**
   * Construct carousel.
   */
  const navigationVisibility = () => {
    document
      .querySelector(discountSelectors.prevButton)
      .classList.toggle('hidden', innerWidth >= 990 && document.querySelectorAll(discountSelectors.slide).length <= 3);
    document
      .querySelector(discountSelectors.nextButton)
      .classList.toggle('hidden', innerWidth >= 990 && document.querySelectorAll(discountSelectors.slide).length <= 3);
  };

  const initializeDiscountSlider = () => {
    if (typeof Swiper !== 'undefined') {
      new Swiper(document.querySelector(discountSelectors.container), {
        slidesPerView: 3,
        allowTouchMove: false,
        watchSlidesProgress: true,
        navigation: {
          nextEl: discountSelectors.nextButton,
          prevEl: discountSelectors.prevButton
        },
        breakpoints: {
          990: {
            slidesPerView: 1,
            allowTouchMove: true
          }
        },
        on: {
          init: navigationVisibility,
          resize: navigationVisibility
        }
      });
    } else {
      setTimeout(initializeDiscountSlider, 100);
    }
  };

  initializeDiscountSlider();
  window.addEventListener('resize', navigationVisibility);
});
